"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _utils = require("@ckeditor/ckeditor5-ui/src/dropdown/utils");

var _splitbuttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/dropdown/button/splitbuttonview"));

var _imageinsert = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageinsert"));

var _imageinsertui = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageinsert/imageinsertui"));

var _imageinsertpanelview = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageinsert/ui/imageinsertpanelview"));

var _utils2 = require("@ckeditor/ckeditor5-image/src/imageinsert/utils");

var _image = _interopRequireDefault(require("@ckeditor/ckeditor5-core/theme/icons/image.svg"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * adapted from https://github.com/ckeditor/ckeditor5/blob/master/packages/ckeditor5-image/src/imageinsert/imageinsertui.js
 */
var InsertImageByUrl = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(InsertImageByUrl, _Plugin);

  var _super = _createSuper(InsertImageByUrl);

  function InsertImageByUrl() {
    (0, _classCallCheck2["default"])(this, InsertImageByUrl);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(InsertImageByUrl, [{
    key: "init",
    value: function init() {
      var _this = this;

      var editor = this.editor;

      var componentCreator = function componentCreator(locale) {
        return _this.createDropdownView(locale);
      };

      editor.ui.componentFactory.add('grooveInsertImage', componentCreator);
    }
  }, {
    key: "isGrooveImageUploadPluginEnabled",
    value: function isGrooveImageUploadPluginEnabled() {
      return this.editor.plugins.has('GrooveImageUploadUI');
    } // If GrooveImagePlugin plugin is enabled, we attach the insert image via url to it as a splitbutton

  }, {
    key: "createDropdownView",
    value: function createDropdownView(locale) {
      if (this.isGrooveImageUploadPluginEnabled()) {
        return this.createDropdownWithUploadImageView(locale);
      }

      return this.createStandAloneDropdownView(locale);
    } // creates a dropdown with only insert image via url as an option

  }, {
    key: "createStandAloneDropdownView",
    value: function createStandAloneDropdownView(locale) {
      var editor = this.editor;
      var imageInsertView = new _imageinsertpanelview["default"](locale, (0, _utils2.prepareIntegrations)(editor));
      var command = editor.commands.get('uploadImage');
      var dropdownView = this.imageInsertPanelDropdownView(locale);
      return this._setUpDropdown(dropdownView, imageInsertView, command);
    } // creates a SplitButtonView
    // first button is groove image upload
    // second is insert image via url dropdown

  }, {
    key: "createDropdownWithUploadImageView",
    value: function createDropdownWithUploadImageView(locale) {
      var editor = this.editor;
      var imageInsertView = new _imageinsertpanelview["default"](locale, (0, _utils2.prepareIntegrations)(editor));
      var command = editor.commands.get('grooveUploadImage');
      var dropdownView = this.imageInsertPanelSplitButtonView(locale);
      var splitButtonView = dropdownView.buttonView; // this binds the grooveimageuploadui to the first button in the split

      splitButtonView.actionView = editor.ui.componentFactory.create('grooveUploadImage'); // After we replaced action button with `uploadImage` component,
      // we have lost a proper styling and some minor visual quirks have appeared.
      // Brining back original split button classes helps fix the button styling
      // See https://github.com/ckeditor/ckeditor5/issues/7986.

      splitButtonView.actionView.extendTemplate({
        attributes: {
          "class": 'ck ck-button ck-splitbutton__action'
        }
      });
      return this._setUpDropdown(dropdownView, imageInsertView, command);
    }
  }, {
    key: "imageInsertPanelDropdownView",
    value: function imageInsertPanelDropdownView(locale) {
      var t = locale.t;
      var dropdownView = (0, _utils.createDropdown)(locale);
      var panelView = dropdownView.panelView;
      dropdownView.buttonView.set({
        label: t('Insert image via URL'),
        icon: _image["default"],
        tooltip: true
      });
      panelView.extendTemplate({
        attributes: {
          "class": 'ck-image-insert__panel'
        }
      });
      return dropdownView;
    }
  }, {
    key: "imageInsertPanelSplitButtonView",
    value: function imageInsertPanelSplitButtonView(locale) {
      var t = locale.t;
      var dropdownView = (0, _utils.createDropdown)(locale, _splitbuttonview["default"]);
      var splitButtonView = dropdownView.buttonView;
      var panelView = dropdownView.panelView;
      splitButtonView.set({
        label: t('Insert image'),
        icon: _image["default"],
        tooltip: true
      });
      panelView.extendTemplate({
        attributes: {
          "class": 'ck-image-insert__panel'
        }
      });
      return dropdownView;
    } // instead of copying the whole _setUpDropdown method here,
    // call the method from the already instantiated ImageInsertUI plugin's instance to keep this class lean

  }, {
    key: "_setUpDropdown",
    value: function _setUpDropdown(dropdownView, imageInsertView, command) {
      var imageInsertUIplugin = this.editor.plugins.get('ImageInsertUI'); // eslint-disable-next-line no-underscore-dangle

      return imageInsertUIplugin._setUpDropdown(dropdownView, imageInsertView, command);
    }
  }], [{
    key: "requires",
    get: function get() {
      return [_imageinsert["default"], _imageinsertui["default"]];
    }
  }]);
  return InsertImageByUrl;
}(_plugin["default"]);

exports["default"] = InsertImageByUrl;
//# sourceMappingURL=index.js.map